<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <DIV
    v-if="loaded"
  >
    <ItpFormGroup
      name="contract_service"
      :label="'Contract service'|pgettext('BillingListItem')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
    >
      <UcContractServiceSelector
        :item="item"
        path="contract_service"
        :readonly="isReadonly"
        clearable
        @optionSelected="evh_6466705138206980_optionSelected($event, {})"
      >
      </UcContractServiceSelector>
    </ItpFormGroup>
    <ItpFormGroup
      name="contract"
      :label="'Contract'|pgettext('BillingListItem')"
      labelColsMd="3"
      contentColsMd="8"
      :labelAlign="labelAlign"
    >
      <UcContractSelector
        name="contract"
        :item="item"
        path="contract"
        :readonly="isReadonly"
        clearable
        @optionSelected="evh_3943151158818434_optionSelected($event, {})"
      >
      </UcContractSelector>
    </ItpFormGroup>
    <ItpFormGroup
      name="description"
      :label="'Description'|pgettext('BillingListItem')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
      required
    >
      <ItpFormInput
        name="description"
        v-model="item.description"
        :readonly="isReadonly"
        required
      >
      </ItpFormInput>
    </ItpFormGroup>
    <ItpFormGroup
      name="notes"
      :label="'Note'|pgettext('BillingListItem')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
    >
      <ItpFormTextarea
        name="notes"
        v-model="item.notes"
        :readonly="isReadonly"
      >
      </ItpFormTextarea>
    </ItpFormGroup>
    <ItpFormGroup
      name="billing_category"
      :label="'Billing category'|pgettext('BillingListItem')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
    >
      <ItpFormInput
        name="billing_category"
        v-model="item.billing_category"
        :readonly="isReadonly"
      >
      </ItpFormInput>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="2"
      name="invoice_date"
      :label="'Billing due date'|pgettext('BillingListItem')"
      :labelAlign="labelAlign"
      required
    >
      <ItpFormDatetime
        name="invoice_date"
        v-model="item.invoice_date"
        :readonly="isReadonly"
        required
      >
      </ItpFormDatetime>
    </ItpFormGroup>
    <ItpFormGroup
      name="company"
      :label="'Billing company'|pgettext('BillingListItem')"
      labelColsMd="3"
      contentColsMd="8"
      :labelAlign="labelAlign"
      required
    >
      <UcCompanySelector
        name="company"
        :item="item"
        path="company"
        :parameters="b_6610553441758910_parameters"
        required
        :readonly="isReadonly"
      >
      </UcCompanySelector>
    </ItpFormGroup>
    <ItpFormGroup
      name="client"
      :label="'Client'|pgettext('BillingListItem')"
      labelColsMd="3"
      contentColsMd="8"
      :labelAlign="labelAlign"
      required
    >
      <UcCompanySelector
        name="partner"
        :item="item"
        path="partner"
        required
        :readonly="isReadonly"
      >
      </UcCompanySelector>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="2"
      name="due_date"
      :label="'Payment due date'|pgettext('BillingListItem')"
      :labelAlign="labelAlign"
      required
    >
      <ItpFormDatetime
        name="due_date"
        v-model="item.due_date"
        required
        :readonly="isReadonly"
      >
      </ItpFormDatetime>
    </ItpFormGroup>
    <ItpFormGroup
      name="period"
      :label="'Billing period'|pgettext('BillingListItem')"
      labelColsMd="3"
      contentColsMd="8"
      :labelAlign="labelAlign"
      contentClass="form-row"
      v-if="item.period"
    >
      <DIV
        class="col-3"
      >
        <ItpFormDatetime
          name="billing_period_start"
          v-model="item.period.start"
          :readonly="isReadonly"
          :placeholder="'From'|pgettext('BillingPeriod')"
        >
        </ItpFormDatetime>
      </DIV>
      <DIV
        class="col-3"
      >
        <ItpFormDatetime
          name="billing_period_end"
          v-model="item.period.end"
          :placeholder="'To'|pgettext('BillingPeriod')"
          :readonly="isReadonly"
        >
        </ItpFormDatetime>
      </DIV>
    </ItpFormGroup>
    <hr>
    </hr>
    <ItpFormGroup
      name="base_price"
      :label="'Base price'|pgettext('BillingListItem')"
      labelColsMd="3"
      contentColsMd="8"
      :labelAlign="labelAlign"
    >
      <MonetaryAmountFieldset
        name="base_price"
        :item="item"
        path="base_price"
        :readonly="isReadonly"
        class="form-row"
        @changed="evh_5685441140616476_changed($event, {})"
      >
      </MonetaryAmountFieldset>
    </ItpFormGroup>
    <ItpFormGroup
      name="currency"
      :label="'Exchange rate'|pgettext('BillingListItem')"
      labelColsMd="3"
      contentColsMd="8"
      :labelAlign="labelAlign"
      contentClass="form-row"
    >
      <DIV
        class="col-3"
      >
        <ItpFormInput
          mask="number"
          unmask="typed"
          scale="2"
          name="exchange_rate"
          v-model="exchange_rate.value"
          :readonly="isReadonly"
          :placeholder="'Rate'|pgettext('Invoice')"
          @blur="evh_1175399472650195_blur($event, {})"
        >
        </ItpFormInput>
      </DIV>
      <DIV
        class="col-4"
      >
        <ItpFormDatetime
          name="exchange_rate_date"
          v-model="exchange_rate.date"
          :readonly="isReadonly"
          :placeholder="'Date'|pgettext('Invoice')"
          @blur="evh_2786108381738342_blur($event, {})"
        >
        </ItpFormDatetime>
      </DIV>
      <DIV
        class="col-5"
      >
        <ItpFormSelect
          name="exchange_rate_source"
          v-model="exchange_rate.source"
          :options="exchangeRateSources"
          :readonly="isReadonly"
          :placeholder="'Source'|pgettext('ExchangeRateFieldset')"
          valueField="value"
          textField="name"
          null-option
          @blur="evh_7888454496860501_blur($event, {})"
        >
        </ItpFormSelect>
      </DIV>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="8"
      name="quantity"
      :label="'Quantity'|pgettext('BillingListItem')"
      :labelAlign="labelAlign"
      required
      contentClass="form-row"
    >
      <DIV
        class="col-4"
      >
        <ItpFormInput
          mask="number"
          unmask="typed"
          :scale="invoiceLineCalculator.digits.quantity"
          name="quantity"
          v-model="item.quantity"
          required
          :readonly="isReadonly"
          @blur="evh_5418559842130999_blur($event, {})"
        >
        </ItpFormInput>
      </DIV>
      <DIV
        class="col-3"
      >
        <ItpFormInput
          name="unit"
          v-model="item.unit"
          required
          :readonly="isReadonly"
        >
        </ItpFormInput>
      </DIV>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="8"
      name="price"
      :label="'Price'|pgettext('BillingListItem')"
      :labelAlign="labelAlign"
      required
      contentClass="form-row"
    >
      <DIV
        class="col-4"
      >
        <ItpFormInput
          name="price"
          mask="number"
          unmask="typed"
          :scale="invoiceLineCalculator.digits.unitPrice"
          v-model="item.price"
          required
          :readonly="isReadonly"
          @blur="evh_7916821937533317_blur($event, {})"
        >
        </ItpFormInput>
      </DIV>
      <DIV
        class="col-3"
      >
        <CurrencySelector
          name="currency"
          :item="item"
          path="currency"
          :readonly="isReadonly"
          @input="evh_4441335657753065_input($event, {})"
        >
        </CurrencySelector>
      </DIV>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="2"
      name="discount"
      :label="'Discount'|pgettext('BillingListItem')"
      :labelAlign="labelAlign"
      required
      contentClass="input-group"
    >
      <ItpFormInput
        name="discount"
        type="number"
        v-model="item.discount"
        min="0"
        max="100"
        required
        :readonly="isReadonly"
        @blur="evh_6529453708504681_blur($event, {})"
      >
      </ItpFormInput>
      <div
        class="input-group-append"
      >
        <span
          class="input-group-text"
        >
          &percnt;
        </span>
      </div>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="2"
      name="net_amount"
      :label="'Net'|pgettext('BillingListItem')"
      :labelAlign="labelAlign"
      required
    >
      <ItpFormInput
        name="net_amount"
        mask="number"
        unmask="typed"
        :scale="invoiceLineCalculator.digits.amounts"
        v-model="item.net_amount"
        required
        :readonly="isReadonly"
        @blur="evh_2837120413286864_blur($event, {})"
      >
      </ItpFormInput>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="2"
      name="tax_code"
      :label="'VAT code'|pgettext('BillingListItem')"
      :labelAlign="labelAlign"
      required
    >
      <TaxCodeSelector
        name="tax_code"
        :item="item"
        path="tax_code"
        :readonly="isReadonly"
        @blur="evh_1200777560175496_blur($event, {})"
      >
      </TaxCodeSelector>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="2"
      name="amount"
      mask="number"
      unmask="typed"
      :scale="invoiceLineCalculator.digits.amounts"
      :label="'Amount'|pgettext('BillingListItem')"
      :labelAlign="labelAlign"
      required
    >
      <ItpFormInput
        name="amount"
        mask="number"
        unmask="typed"
        v-model="item.amount"
        required
        :readonly="isReadonly"
        @blur="evh_6300315092833989_blur($event, {})"
      >
      </ItpFormInput>
    </ItpFormGroup>
  </DIV>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class FieldsetBillingListItem extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  currentCurrency(...args: any[]) {
    return _.find(this.currencies, { code: this.item.currency });
  }

  createInvoiceLineCalculator(...args: any[]) {
    const [force] = args;

    if (force === true || this._invoiceLineCalculator == null) {
      const currency = this.currentCurrency();
      if (currency == null) {
        return;
      }
      this._invoiceLineCalculator = new this.$app.helpers.InvoiceLineCalculator(currency, this.taxCodes);
    }
    return this._invoiceLineCalculator;
  }

  syncExchangeRate(...args: any[]) {
    const v = this.exchange_rate
    this.item.exchange_rate = v.value == null ? null : v

    if (this._invoiceLineCalculator) {
      this._invoiceLineCalculator.recalculateLineItem(this.item, 'base_price');
    }
  }

  onContractChanged(...args: any[]) {
    const contract = this.item.contract
    if (contract) {
      this.item.company = contract.company
      this.item.partner = contract.client
      this.item.rental = contract.rental
    }
  }

  onContractServiceChanged(...args: any[]) {
    const contract_service = this.item.contract_service
    if (contract_service) {
      this.item.contract = contract_service.contract
      this.item.description = contract_service.name
      if (contract_service.invoice_notes) {
        this.item.notes = contract_service.invoice_notes
      }
      this.onContractChanged();
      this.getCurrentServicePrice(contract_service.id)
    }
  }

  getCurrentServicePrice(...args: any[]) {
    const [id] = args;
    this.$fn.fetch('read_contract_service', { parameters: { id } })
      .then(res => {
        if (!res.current_fee) {
          return;
        }

        const fee = res.current_fee;

        this.item.base_price = { amount: fee.amount, currency: fee.currency }

        if (this.item.currency != res.billing_currency) {
          this.item.currency = res.billing_currency;
          this.createInvoiceLineCalculator(true);
        }
        this.invoiceLineCalculator.applyContractServiceFee(
          this.item, res, res.current_fee
        );
      });
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  @Prop({
    type: Object,
  })
  form!: object;

  @Watch('form')
  onForm(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("form")
  }

  @Prop({
    type: Boolean,
  })
  isSaving!: boolean;

  @Watch('isSaving')
  onIs_saving(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("isSaving")
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$app.repo.get('list_currency')
  }

  taxCodes!: any;

  async $$load_taxCodes() {
    return this.$app.repo.get('list_tax_code')
  }

  invoiceLineCalculator!: any;

  async $$load_invoiceLineCalculator() {
    return this.createInvoiceLineCalculator()
  }

  exchange_rate!: any;

  async $$load_exchange_rate() {
    return this.item.exchange_rate || { value: null, date: null, source: null }
  }

  base_price!: any;

  async $$load_base_price() {
    return _.extend({ amount: null, currency: null }, this.item.base_price)
  }

  exchangeRateSources!: any;

  async $$load_exchangeRateSources() {
    return this.$app.repo.get('ui_metadata', { path: 'exchange_rate_source_options' })
  }

  ux!: any;
  b_6610553441758910_parameters!: any;
  dataMembers = ['currencies', 'taxCodes', 'invoiceLineCalculator', 'exchange_rate', 'base_price', 'exchangeRateSources', 'ux', 'b_6610553441758910_parameters'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        currencies: null,
        taxCodes: null,
        invoiceLineCalculator: null,
        exchange_rate: null,
        base_price: null,
        exchangeRateSources: null,
        ux: null,
        b_6610553441758910_parameters: {
          role: "own",
        }
        ,
      },
    }
  }

  get isReadonly() {
    if (this.loaded) {

      return this.item.isReadonly || false
    }
    return null;
  }

  get currency() {
    if (this.loaded) {

      return _.find(this.currencies, { code: this.item.currency })
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_script_6596_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6466705138206980_script_6596, alias=undefined
    this.onContractServiceChanged()
  }

  async act_6466705138206980_script_6596_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6466705138206980_script_6596, alias=undefined
    return {
      value: () => this.act_6466705138206980_script_6596_getActionArgs_value($event),
    }
  }

  async evh_6466705138206980_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_optionSelected.executeFromDOM(this, event, scope);
  }

  async act_3943151158818434_script_6598_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3943151158818434_script_6598, alias=undefined
    this.onContractChanged()
  }

  async act_3943151158818434_script_6598_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3943151158818434_script_6598, alias=undefined
    return {
      value: () => this.act_3943151158818434_script_6598_getActionArgs_value($event),
    }
  }

  async evh_3943151158818434_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3943151158818434_optionSelected.executeFromDOM(this, event, scope);
  }

  async act_5685441140616476_script_6600_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5685441140616476_script_6600, alias=undefined
    this.invoiceLineCalculator.recalculateLineItem(this.item, 'base_price')
  }

  async act_5685441140616476_script_6600_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5685441140616476_script_6600, alias=undefined
    return {
      value: () => this.act_5685441140616476_script_6600_getActionArgs_value($event),
    }
  }

  async evh_5685441140616476_changed(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5685441140616476_changed.executeFromDOM(this, event, scope);
  }

  async act_1175399472650195_script_6602_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1175399472650195_script_6602, alias=undefined
    this.syncExchangeRate()
  }

  async act_1175399472650195_script_6602_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1175399472650195_script_6602, alias=undefined
    return {
      value: () => this.act_1175399472650195_script_6602_getActionArgs_value($event),
    }
  }

  async evh_1175399472650195_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1175399472650195_blur.executeFromDOM(this, event, scope);
  }

  async act_2786108381738342_script_6604_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2786108381738342_script_6604, alias=undefined
    this.syncExchangeRate()
  }

  async act_2786108381738342_script_6604_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2786108381738342_script_6604, alias=undefined
    return {
      value: () => this.act_2786108381738342_script_6604_getActionArgs_value($event),
    }
  }

  async evh_2786108381738342_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2786108381738342_blur.executeFromDOM(this, event, scope);
  }

  async act_7888454496860501_script_6606_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7888454496860501_script_6606, alias=undefined
    this.syncExchangeRate()
  }

  async act_7888454496860501_script_6606_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7888454496860501_script_6606, alias=undefined
    return {
      value: () => this.act_7888454496860501_script_6606_getActionArgs_value($event),
    }
  }

  async evh_7888454496860501_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7888454496860501_blur.executeFromDOM(this, event, scope);
  }

  async act_5418559842130999_script_6608_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5418559842130999_script_6608, alias=undefined
    this.invoiceLineCalculator.recalculateLineItem(this.item, 'quantity')
  }

  async act_5418559842130999_script_6608_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5418559842130999_script_6608, alias=undefined
    return {
      value: () => this.act_5418559842130999_script_6608_getActionArgs_value($event),
    }
  }

  async evh_5418559842130999_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5418559842130999_blur.executeFromDOM(this, event, scope);
  }

  async act_7916821937533317_script_6610_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7916821937533317_script_6610, alias=undefined
    this.invoiceLineCalculator.recalculateLineItem(this.item, 'price')
  }

  async act_7916821937533317_script_6610_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7916821937533317_script_6610, alias=undefined
    return {
      value: () => this.act_7916821937533317_script_6610_getActionArgs_value($event),
    }
  }

  async evh_7916821937533317_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7916821937533317_blur.executeFromDOM(this, event, scope);
  }

  async act_4441335657753065_setData_6612_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_4441335657753065_setData_6612, alias=undefined
    return {
      path: "invoiceLineCalculator",
      value: this.createInvoiceLineCalculator(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_4441335657753065_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4441335657753065_input.executeFromDOM(this, event, scope);
  }

  async act_6529453708504681_script_6614_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6529453708504681_script_6614, alias=undefined
    this.invoiceLineCalculator.recalculateLineItem(this.item, 'discount')
  }

  async act_6529453708504681_script_6614_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6529453708504681_script_6614, alias=undefined
    return {
      value: () => this.act_6529453708504681_script_6614_getActionArgs_value($event),
    }
  }

  async evh_6529453708504681_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6529453708504681_blur.executeFromDOM(this, event, scope);
  }

  async act_2837120413286864_script_6616_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2837120413286864_script_6616, alias=undefined
    this.invoiceLineCalculator.recalculateLineItem(this.item, 'net_amount')
  }

  async act_2837120413286864_script_6616_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2837120413286864_script_6616, alias=undefined
    return {
      value: () => this.act_2837120413286864_script_6616_getActionArgs_value($event),
    }
  }

  async evh_2837120413286864_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2837120413286864_blur.executeFromDOM(this, event, scope);
  }

  async act_1200777560175496_script_6618_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1200777560175496_script_6618, alias=undefined
    this.invoiceLineCalculator.recalculateLineItem(this.item, 'tax_code')
  }

  async act_1200777560175496_script_6618_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1200777560175496_script_6618, alias=undefined
    return {
      value: () => this.act_1200777560175496_script_6618_getActionArgs_value($event),
    }
  }

  async evh_1200777560175496_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1200777560175496_blur.executeFromDOM(this, event, scope);
  }

  async act_6300315092833989_script_6620_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6300315092833989_script_6620, alias=undefined
    this.invoiceLineCalculator.recalculateLineItem(this.item, 'amount')
  }

  async act_6300315092833989_script_6620_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6300315092833989_script_6620, alias=undefined
    return {
      value: () => this.act_6300315092833989_script_6620_getActionArgs_value($event),
    }
  }

  async evh_6300315092833989_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6300315092833989_blur.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_6594: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_6593: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_6466705138206980_script_6596: actions.ScriptAction;
    evh_6466705138206980_optionSelected_6595: actions.EventHandlerImpl;
    evh_6466705138206980_optionSelected: actions.EventHandlerGroup;
    act_3943151158818434_script_6598: actions.ScriptAction;
    evh_3943151158818434_optionSelected_6597: actions.EventHandlerImpl;
    evh_3943151158818434_optionSelected: actions.EventHandlerGroup;
    act_5685441140616476_script_6600: actions.ScriptAction;
    evh_5685441140616476_changed_6599: actions.EventHandlerImpl;
    evh_5685441140616476_changed: actions.EventHandlerGroup;
    act_1175399472650195_script_6602: actions.ScriptAction;
    evh_1175399472650195_blur_6601: actions.EventHandlerImpl;
    evh_1175399472650195_blur: actions.EventHandlerGroup;
    act_2786108381738342_script_6604: actions.ScriptAction;
    evh_2786108381738342_blur_6603: actions.EventHandlerImpl;
    evh_2786108381738342_blur: actions.EventHandlerGroup;
    act_7888454496860501_script_6606: actions.ScriptAction;
    evh_7888454496860501_blur_6605: actions.EventHandlerImpl;
    evh_7888454496860501_blur: actions.EventHandlerGroup;
    act_5418559842130999_script_6608: actions.ScriptAction;
    evh_5418559842130999_blur_6607: actions.EventHandlerImpl;
    evh_5418559842130999_blur: actions.EventHandlerGroup;
    act_7916821937533317_script_6610: actions.ScriptAction;
    evh_7916821937533317_blur_6609: actions.EventHandlerImpl;
    evh_7916821937533317_blur: actions.EventHandlerGroup;
    act_4441335657753065_setData_6612: actions.SetDataAction;
    evh_4441335657753065_input_6611: actions.EventHandlerImpl;
    evh_4441335657753065_input: actions.EventHandlerGroup;
    act_6529453708504681_script_6614: actions.ScriptAction;
    evh_6529453708504681_blur_6613: actions.EventHandlerImpl;
    evh_6529453708504681_blur: actions.EventHandlerGroup;
    act_2837120413286864_script_6616: actions.ScriptAction;
    evh_2837120413286864_blur_6615: actions.EventHandlerImpl;
    evh_2837120413286864_blur: actions.EventHandlerGroup;
    act_1200777560175496_script_6618: actions.ScriptAction;
    evh_1200777560175496_blur_6617: actions.EventHandlerImpl;
    evh_1200777560175496_blur: actions.EventHandlerGroup;
    act_6300315092833989_script_6620: actions.ScriptAction;
    evh_6300315092833989_blur_6619: actions.EventHandlerImpl;
    evh_6300315092833989_blur: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_6594 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_6593 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_6594,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_6593],
      }
    );
    const act_6466705138206980_script_6596 = new actions.ScriptAction(
      {
        actionArgs: this.act_6466705138206980_script_6596_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_optionSelected_6595 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_script_6596,
        event: "optionSelected",
        displayName: "script",
      }
    );
    const evh_6466705138206980_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_optionSelected_6595],
      }
    );
    const act_3943151158818434_script_6598 = new actions.ScriptAction(
      {
        actionArgs: this.act_3943151158818434_script_6598_getActionArgs,
        events: [],
      }
    );
    const evh_3943151158818434_optionSelected_6597 = new actions.EventHandlerImpl(
      {
        action: act_3943151158818434_script_6598,
        event: "optionSelected",
        displayName: "script",
      }
    );
    const evh_3943151158818434_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_3943151158818434_optionSelected_6597],
      }
    );
    const act_5685441140616476_script_6600 = new actions.ScriptAction(
      {
        actionArgs: this.act_5685441140616476_script_6600_getActionArgs,
        events: [],
      }
    );
    const evh_5685441140616476_changed_6599 = new actions.EventHandlerImpl(
      {
        action: act_5685441140616476_script_6600,
        event: "changed",
        displayName: "script",
      }
    );
    const evh_5685441140616476_changed = new actions.EventHandlerGroup(
      {
        handlers: [evh_5685441140616476_changed_6599],
      }
    );
    const act_1175399472650195_script_6602 = new actions.ScriptAction(
      {
        actionArgs: this.act_1175399472650195_script_6602_getActionArgs,
        events: [],
      }
    );
    const evh_1175399472650195_blur_6601 = new actions.EventHandlerImpl(
      {
        action: act_1175399472650195_script_6602,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_1175399472650195_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_1175399472650195_blur_6601],
      }
    );
    const act_2786108381738342_script_6604 = new actions.ScriptAction(
      {
        actionArgs: this.act_2786108381738342_script_6604_getActionArgs,
        events: [],
      }
    );
    const evh_2786108381738342_blur_6603 = new actions.EventHandlerImpl(
      {
        action: act_2786108381738342_script_6604,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_2786108381738342_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_2786108381738342_blur_6603],
      }
    );
    const act_7888454496860501_script_6606 = new actions.ScriptAction(
      {
        actionArgs: this.act_7888454496860501_script_6606_getActionArgs,
        events: [],
      }
    );
    const evh_7888454496860501_blur_6605 = new actions.EventHandlerImpl(
      {
        action: act_7888454496860501_script_6606,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_7888454496860501_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_7888454496860501_blur_6605],
      }
    );
    const act_5418559842130999_script_6608 = new actions.ScriptAction(
      {
        actionArgs: this.act_5418559842130999_script_6608_getActionArgs,
        events: [],
      }
    );
    const evh_5418559842130999_blur_6607 = new actions.EventHandlerImpl(
      {
        action: act_5418559842130999_script_6608,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_5418559842130999_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_5418559842130999_blur_6607],
      }
    );
    const act_7916821937533317_script_6610 = new actions.ScriptAction(
      {
        actionArgs: this.act_7916821937533317_script_6610_getActionArgs,
        events: [],
      }
    );
    const evh_7916821937533317_blur_6609 = new actions.EventHandlerImpl(
      {
        action: act_7916821937533317_script_6610,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_7916821937533317_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_7916821937533317_blur_6609],
      }
    );
    const act_4441335657753065_setData_6612 = new actions.SetDataAction(
      {
        actionArgs: this.act_4441335657753065_setData_6612_getActionArgs,
        events: [],
      }
    );
    const evh_4441335657753065_input_6611 = new actions.EventHandlerImpl(
      {
        action: act_4441335657753065_setData_6612,
        event: "input",
        displayName: "setData",
      }
    );
    const evh_4441335657753065_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_4441335657753065_input_6611],
      }
    );
    const act_6529453708504681_script_6614 = new actions.ScriptAction(
      {
        actionArgs: this.act_6529453708504681_script_6614_getActionArgs,
        events: [],
      }
    );
    const evh_6529453708504681_blur_6613 = new actions.EventHandlerImpl(
      {
        action: act_6529453708504681_script_6614,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_6529453708504681_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_6529453708504681_blur_6613],
      }
    );
    const act_2837120413286864_script_6616 = new actions.ScriptAction(
      {
        actionArgs: this.act_2837120413286864_script_6616_getActionArgs,
        events: [],
      }
    );
    const evh_2837120413286864_blur_6615 = new actions.EventHandlerImpl(
      {
        action: act_2837120413286864_script_6616,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_2837120413286864_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_2837120413286864_blur_6615],
      }
    );
    const act_1200777560175496_script_6618 = new actions.ScriptAction(
      {
        actionArgs: this.act_1200777560175496_script_6618_getActionArgs,
        events: [],
      }
    );
    const evh_1200777560175496_blur_6617 = new actions.EventHandlerImpl(
      {
        action: act_1200777560175496_script_6618,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_1200777560175496_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_1200777560175496_blur_6617],
      }
    );
    const act_6300315092833989_script_6620 = new actions.ScriptAction(
      {
        actionArgs: this.act_6300315092833989_script_6620_getActionArgs,
        events: [],
      }
    );
    const evh_6300315092833989_blur_6619 = new actions.EventHandlerImpl(
      {
        action: act_6300315092833989_script_6620,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_6300315092833989_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_6300315092833989_blur_6619],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_6594,
      evh_7315092382398562_reload_6593,
      evh_7315092382398562_reload,
      act_6466705138206980_script_6596,
      evh_6466705138206980_optionSelected_6595,
      evh_6466705138206980_optionSelected,
      act_3943151158818434_script_6598,
      evh_3943151158818434_optionSelected_6597,
      evh_3943151158818434_optionSelected,
      act_5685441140616476_script_6600,
      evh_5685441140616476_changed_6599,
      evh_5685441140616476_changed,
      act_1175399472650195_script_6602,
      evh_1175399472650195_blur_6601,
      evh_1175399472650195_blur,
      act_2786108381738342_script_6604,
      evh_2786108381738342_blur_6603,
      evh_2786108381738342_blur,
      act_7888454496860501_script_6606,
      evh_7888454496860501_blur_6605,
      evh_7888454496860501_blur,
      act_5418559842130999_script_6608,
      evh_5418559842130999_blur_6607,
      evh_5418559842130999_blur,
      act_7916821937533317_script_6610,
      evh_7916821937533317_blur_6609,
      evh_7916821937533317_blur,
      act_4441335657753065_setData_6612,
      evh_4441335657753065_input_6611,
      evh_4441335657753065_input,
      act_6529453708504681_script_6614,
      evh_6529453708504681_blur_6613,
      evh_6529453708504681_blur,
      act_2837120413286864_script_6616,
      evh_2837120413286864_blur_6615,
      evh_2837120413286864_blur,
      act_1200777560175496_script_6618,
      evh_1200777560175496_blur_6617,
      evh_1200777560175496_blur,
      act_6300315092833989_script_6620,
      evh_6300315092833989_blur_6619,
      evh_6300315092833989_blur,
    }
  }
}

Vue.component("FieldsetBillingListItem", FieldsetBillingListItem);

</script>